import React, { Component } from 'react';
import { Grid, } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import useStyles from './styles';
import WMLeftSection from './WMLeftSection';
import WMRightSection from './WMRightSection';
import WMMobileSection from './WMMobileSection';
import moment from 'moment';

class WMLeaderboard extends Component {
    constructor(props){
        super(props);
        this.state = {
            quarter_index: 0,
            page_number: 1,
            selected: props.chapters ? props.chapters[0] : {},
            width: window.innerWidth,
            height: window.innerHeight,
        }

        this.changeChapter = this.changeChapter.bind(this);
        this.changePage = this.changePage.bind(this);
        this.resizeWindow = this.resizeWindow.bind(this);
        window.addEventListener('resize', this.resizeWindow);
    }

    componentDidMount(){
        const { chapters } = this.props;
        const today = moment();
        let selected, quarter_index;
        chapters.forEach((ch, i) => {
            if(!selected){
                if(i == 0 && today.isBefore(ch.quarter_start_date)){
                    selected = ch;
                    quarter_index = i;
                } else if(today.isSameOrAfter(ch.quarter_start_date) && today.isBefore(ch.quarter_end_date)){
                    selected = ch;
                    quarter_index = i;
                } else if(i == chapters.length - 1){
                    // If no chapters are open
                    selected = chapters[i];
                    quarter_index = i;
                }
            }
        });

        this.setState({
            selected: selected,
            quarter_index: quarter_index,
        });
    }

    changeChapter(n){
        const new_val = this.state.quarter_index + n;
        const chapters = this.props.chapters;
        if(chapters[new_val] && chapters[new_val].quarter_number){
            this.setState({
                quarter_index: new_val,
                selected: chapters[new_val],
                page_number: 1,
            });
        }
    }

    changePage(page){
        if(page > 0){
            this.setState({
                page_number: page
            });
        }
    }

    resizeWindow(){
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }

    render(){
        const { classes, event_token, chapters, guest_token, event, } = this.props;
        const { quarter_index, page_number, selected, width, height, } = this.state;
        const quarter_id = selected.quarter_number != null && selected.quarter_number != undefined ? selected.quarter_number : 1;
        const mobile = width < 768 || (width > height && height < 768);
        const urlParams = new URLSearchParams(window.location.search);
        const showOverlay = urlParams.get('overlay') === 'true';

        if(mobile){
            return (
                <Grid container>
                    <WMMobileSection
                        event_id={event._id}
                        event_token={event_token}
                        guest_token={guest_token}
                        quarter_id={quarter_id}
                        quarter_index={quarter_index}
                        page_number={page_number}
                        changePage={this.changePage}
                        changeChapter={this.changeChapter}
                        chapters={chapters}
                        current_chapter={selected}
                        landscape={width > height && height < 768}
                    />
                </Grid>
            )
        }
        else return (
            <Grid container>
                <WMLeftSection
                    event_token={event_token}
                    quarter_id={quarter_id}
                    page_number={page_number}
                    changePage={this.changePage}
                    event_id={event._id}
                />
                <WMRightSection
                    event_token={event_token}
                    quarter_id={quarter_id}
                    quarter_index={quarter_index}
                    changeChapter={this.changeChapter}
                    chapters={chapters}
                    current_chapter={selected}
                    guest_token={guest_token}
                    event_id={event._id}
                />
            {showOverlay && (
                <>
                    <div style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(255, 255, 255, 0.4)',
                        zIndex: 999,
                    }} />
                    
                    <div style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        fontSize: '4rem',
                        fontWeight: 'bold',
                        color: '#000',
                        textAlign: 'center',
                        zIndex: 1000,
                        width: '80%',
                        padding: '2rem',
                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                        borderRadius: '8px',
                    }}>
                        COME UPSTAIRS TO PLAY
                    </div>
                </>
            )}
            </Grid>
        )
    }
}

export default withStyles(useStyles)(WMLeaderboard);